import { useState } from "react";
import { Box, Grid } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import CustomText from "../components/CustomText";
import ImageLoader from "../components/ImageLoader";

const AreasAndServices = ({ color, isMobile, dimensionWidth }) => {
  const [index, setIndex] = useState(0);

  const prevCard = () => {
    setIndex((prev) => (prev - 1 + cards.length) % cards.length);
  };

  const currentCard = cards[index];

  const Dimension = dimensionWidth < 1220;
  return (
    <Grid container sx={design.Direction}>
      {!color && (
        <CustomText
          variant="subtitle1"
          color="#000"
          text="Donde la familia es nuestra prioridad"
          sx={design.Title}
        >
          Conoce nuestras áreas y servicios
        </CustomText>
      )}
      <Box mb={!Dimension && 10} style={design.Box}>
        {!Dimension && (
          <>
            <Box style={design.Cursor}>
              <CustomText
                variant="subtitle1"
                color={color ? color : "#2349D0"}
                text="Donde la familia es nuestra prioridad"
                onClick={prevCard}
                sx={design.TextSig}
              >
                <ArrowBack sx={design.Margin} /> Anterior
              </CustomText>
            </Box>

            <Box
              style={{
                backgroundColor: currentCard.leftColors[1],
                ...design.leftColor,
                ...design.leftColorBack,
                left: "-90px",
                overflow: "hidden",
              }}
            />
            <Box
              style={{
                backgroundColor: currentCard.leftColors[0],
                ...design.leftColor,
                left: "-40px",
                overflow: "hidden",
              }}
            />

            <Box
              style={{
                backgroundColor: currentCard.rightColors[1],
                ...design.rightColor,
                ...design.rightColorBack,
                right: "-90px",
                overflow: "hidden",
              }}
            />
            <Box
              style={{
                backgroundColor: currentCard.rightColors[0],
                ...design.rightColor,
                right: "-50px",
                overflow: "hidden",
              }}
            />
          </>
        )}

        <Box
          style={{
            backgroundColor: currentCard.color,
            ...design.BoxPrincipal,
          }}
        >
          <ImageLoader
            src={currentCard.image}
            alt={currentCard.image}
            width={"97%"}
            height={isMobile ? 250 : 450}
          />
          <CustomText
            variant="subtitle1"
            color="#FFF"
            text="Donde la familia es nuestra prioridad"
            sx={design.Description}
          >
            {currentCard.title}
          </CustomText>
          {Dimension && (
            <Grid container sx={design.alignContent}>
              <CustomText
                variant="subtitle1"
                color={"#FFF"}
                text="Donde la familia es nuestra prioridad"
                onClick={prevCard}
                sx={design.TextSig}
              >
                <ArrowBack sx={design.Margin} /> Anterior
              </CustomText>
              <CustomText
                variant="subtitle1"
                color={"#FFF"}
                text="Donde la familia es nuestra prioridad"
                onClick={prevCard}
                sx={design.TextSig}
              >
                Siguiente <ArrowForward sx={design.Arrow} />
              </CustomText>
            </Grid>
          )}
        </Box>
        {!Dimension && (
          <Box style={design.Sig}>
            <CustomText
              variant="subtitle1"
              color={color ? color : "#2349D0"}
              text="Donde la familia es nuestra prioridad"
              onClick={prevCard}
              sx={design.TextSig}
            >
              Siguiente <ArrowForward sx={design.Arrow} />
            </CustomText>
          </Box>
        )}
      </Box>
    </Grid>
  );
};
export default AreasAndServices;
const design = {
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 28,
      sm: 34,
      md: 42,
      lg: 45,
    },
    fontWeight: 600,
    lineHeight: "normal",
    marginTop: "2%",
    textAlign: "center",
  },
  Direction: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: 2,
    paddingRight: 2,
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 18,
    lineHeight: "normal",
    textAlign: "center",
    fontWeight: 700,
    marginTop: 1,
  },
  Box: {
    position: "relative",
    marginTop: 10,
  },
  Cursor: {
    position: "absolute",
    left: "-200px",
    zIndex: 2,
    cursor: "pointer",
    height: "95%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
  },
  TextSig: {
    display: "flex",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 16,
    lineHeight: "normal",
    textAlign: "center",
    fontWeight: 400,
  },
  Margin: { marginRight: 1 },
  prevColor: {
    position: "absolute",
    top: "20px",
    bottom: "0px",
    left: "-50px",
    right: "60%",
    borderRadius: "24px",
    zIndex: 0,
    transition: "background-color 0.3s ease",
  },
  nextColor: {
    position: "absolute",
    top: "20px",
    bottom: "0px",
    left: "60%",
    right: "-50px",
    borderRadius: "24px",
    zIndex: 0,
    transition: "background-color 0.3s ease",
  },
  BoxPrincipal: {
    position: "relative",
    zIndex: 1,
    padding: "10px",
    borderRadius: 15,
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
  },
  Sig: {
    position: "absolute",
    top: "0%",
    right: "-200px",
    zIndex: 2,
    cursor: "pointer",
    height: "90%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
  },
  Arrow: { marginLeft: 1 },
  leftColor: {
    position: "absolute",
    top: "20px",
    bottom: "0px",
    width: "120px",
    height: "90%",
    borderRadius: "24px",
    zIndex: 1,
    transition: "background-color 0.3s ease",
  },
  alignContent: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    gap: 5,
  },
  leftColorBack: {
    top: "30px", // ligeramente más abajo
    transform: "scale(0.9)",
    zIndex: 0,
  },

  rightColor: {
    position: "absolute",
    top: "20px",
    bottom: "0px",
    width: "120px",
    height: "90%",
    borderRadius: "24px",
    zIndex: 1,
    transition: "background-color 0.3s ease",
  },
  rightColorBack: {
    top: "30px",
    transform: "scale(0.9)",
    zIndex: 0,
  },
};
const cards = [
  {
    title: "Urgencias",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Urgencias_del_centro-medico_MEDAM.png",
    color: "rgb(208, 4, 22)",
    leftColors: ["#9FD3A2", "rgba(33, 93, 166, 0.5)"],
    rightColors: ["#9FD3A2", "rgb(217, 217, 217)"],
  },
  {
    title: "Laboratorio",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/recepcion_laboratorio_del_centro-medico_MEDAM.png",
    color: "rgb(72, 158, 77)",
    leftColors: ["rgba(208, 4, 22, 0.5)", "#9FD3A2"],
    rightColors: ["rgb(33, 93, 166)", "#9FD3A2"],
  },
  {
    title: "Cafetería",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/cafeteria_del_centro-medico_MEDAM.png",
    color: "#215DA6",
    leftColors: ["#FB3748", "rgb(217, 217, 217)"],
    rightColors: ["#D0041680", "#9FD3A2"],
  },
];
